import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Stack from '../../../Stack';
import Label from '../../../Label';
import styles from './Step.module.css';
import Circle from '../Circle';

const bindClasses = classNameBind.bind(styles);
const COLOR_MAP = {
  finished: 'blue',
  current: 'white',
  unfinished: 'gray',
};

const Step = ({ icon, index, maxWidth, status, title, appearance }) => (
  <div
    data-ppuc-id="ProgressStepper.Step"
  >
    <Stack verticalAlignment="center" spacing="narrow">
      <Circle
        status={status}
        size={appearance === 'label' ? 'small' : 'medium'}
      >
        {icon ? <Icon name={icon} color={COLOR_MAP[status]} /> : index}
      </Circle>
      <div className={bindClasses('title', status)} style={maxWidth ? { maxWidth } : null}>
        {appearance === 'label' ? (<Label>{title}</Label>) : title}
      </div>
    </Stack>
  </div>
);

Step.defaultProps = {
  icon: null,
  index: 0,
  maxWidth: null,
  status: 'unfinished',
  title: null,
  appearance: 'default',
};

export default Step;
